import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { PaymentService } from '../payment.service';
import THBText from 'thai-baht-text'
import { DatePipe } from 'src/app/shared/pipe/date.pipe';
import pdfMake from 'pdfmake/build/pdfmake';
import { WaterMark } from 'src/app/shared/water-mark';
import { OldChulaLogo_Base64 } from 'src/app/shared/old-chula-logo-base64';
import { PaymentManagementService } from '../../payment-management/payment-management.service';
import { Signature } from 'src/app/shared/signature';

@Component({
  selector: 'app-payment-success',
  templateUrl: './payment-success.component.html',
  styleUrls: ['./payment-success.component.scss']
})
export class PaymentSuccessComponent implements OnInit {
  paymentID: string;
  id: string;
  type: string;
  template: string;
  mid: string;
  checkPaymentStatus: string;
  paymentSuccess: boolean = false;
  statusPayment: any;

  isPrint: boolean = false;
  receiptDetail: any;
  accountId: string = '';

  constructor(
    private router: Router,
    private paymentService: PaymentService,
    private paymentManagementService: PaymentManagementService,
  ) { }

  ngOnInit(): void {
    this.paymentID = new URL(location.href).searchParams.get('pid');
    this.type = new URL(location.href).searchParams.get('type');
    this.id = new URL(location.href).searchParams.get('id');
    this.accountId = new URL(location.href).searchParams.get('ACCOUNTING_ID');

    if (this.type === 'report') {
      this.template = new URL(location.href).searchParams.get('template');
      this.mid = new URL(location.href).searchParams.get('mid');
    }

    // // console.log(this.paymentID);
    // // console.log(this.type);
    // // console.log(this.id);

    this.checkStatusPayment(this.paymentID);

  }

  checkStatusPayment(pid) {
    this.paymentService.getStatusPaymentById(pid).pipe(
      map(res => {
        if (res.success) {
          // console.log(res);
          this.checkPaymentStatus = res.result[0].STATUS_PAYMENT;
          this.statusPayment = res.result[0];
          if (this.checkPaymentStatus !== 'success') {
            this.paymentSuccess = false;
            this.router.navigate(['/']);
            // // console.log(this.checkPaymentStatus);
            // console.log(this.statusPayment);
          } else {
            this.createReceipt();
            this.paymentSuccess = true;
          }
        }
      }),
      catchError((err) => {
        alert('ไม่สามารถทำรายการได้ในขณะนี้ โปรดำเนินการใหม่อีกครั้ง');
        this.router.navigate(['/']);
        return of(false);
      })

    ).subscribe();
  }

  handleEvent(event) {
    if (event.left === 0) {
      this.redirect();
    }
  }

  redirect() {
    // // console.log(this.type);
    switch (this.type) {
      case 'report': {
        window.open('/test-report?type=' + this.template + '&paid=notfree' + '&mid=' + this.mid + '&view_status=1&informant_type=0', '_self');
        break;
      }
      case 'course': {
        window.open('/e-learning/' + this.id, '_self');
        break;
      }
      case 'workshop': {
        window.open('/activity/workshop/' + this.id, '_self');
        break;
      }
      case 'consult': {
        window.open('/', '_self');
        break;
      }
      default: window.open('/', '_self'); break;
    }
  }

  createReceipt() {
    let receipt;
    let today = new Date();

    this.paymentManagementService.getSignature().pipe(
      map(res => {
        // console.log(res);
        if (res.success) {

          receipt = {
            address: '',
            thbath: this.statusPayment.PRICE > 0 ? THBText(this.statusPayment.PRICE) : 'ศูนย์บาท',
            discount: this.statusPayment.PRICE === this.statusPayment.STANDARTPRICE ? 0 : this.statusPayment.STANDARTPRICE - this.statusPayment.SPECIALPRICE,
            price: this.statusPayment.PRICE,
            standardPrice: this.statusPayment.STANDARTPRICE,
            specialPrice: this.statusPayment.SPECIALPRICE,
            type: this.statusPayment.Detail[this.statusPayment.Detail.length - 1].PAYMENT_TYPE === '2C2P' ? 'บัตรเครดิต/เดบิต' : 'เงินโอน',
            paymentID: this.statusPayment.PAYMENT_ID,
            signaturePic1: Signature[0].signature,
            signatureName1: Signature[0].signatureName,
            signatureJobTitle1: Signature[0].position,
            signaturePic2: Signature[1].signature,
            signatureName2: Signature[1].signatureName,
            signatureJobTitle2: Signature[1].position,
            userName: this.statusPayment.NAME,
            userAddress: this.statusPayment.ADDRESS,
            taxID: this.statusPayment.TAX_NO,
            userPhone: this.statusPayment.PAYMENT_PHONENUMBER,
            date: new DatePipe().transform(this.statusPayment.UPDATE_DATE.toString(), 'full'),
            bankDate: today,
            printDate: `${new DatePipe().transform(today.toString(), 'full')} - ${today.getHours() > 9 ? '' : 0}${today.getHours()}:${today.getMinutes() > 9 ? '' : 0}${today.getMinutes()} น.`,
            paymentName: this.statusPayment.PAYMENT_NAME,
            receiptId: this.statusPayment.RECEIPT_ID,
            cardNo: this.statusPayment.Detail[this.statusPayment.Detail.length - 1].CARD_NO,
          }

          this.receiptDetail = receipt;
          this.isPrint = true;
          setTimeout(() => {
            this.isPrint = false;
          }, 1000);

        }
      }),
      catchError((err) => {
        alert(err);
        return of(null);
      })
    ).subscribe();


  }

  sendMail(e) {
    let body = {
      PAYMENT_ID: this.paymentID,
      TRANS_ID: this.statusPayment.Detail[this.statusPayment.Detail.length - 1].TRANS_ID,
      TYPE: this.statusPayment.Detail[this.statusPayment.Detail.length - 1].PAYMENT_TYPE,
      base64str: e,
    };
    // console.log(body);
    this.paymentService.saveBase64ReceiveBillSndMail(body).subscribe();
  }

}
